import React, { useState, useEffect } from "react";
//import { Container, Row, Col, Modal, Button, Form, Dropdown, Table } from 'react-bootstrap';
import "../affiliates/add-affiliates.css";
import DataTable from "react-data-table-component";
import LoadingOverlay from "react-loading-overlay";
import axios from "../../../axios/axios";
import { message } from "antd";
import Modal from "react-bootstrap/Modal";
import moment from "moment";
import { Row, Col, Form } from "react-bootstrap";
import { adminConfig } from "../../../utils/adminConfig";

const customStyles = {
  header: {
    style: {
      minHeight: "56px",
    },
  },
  headRow: {
    style: {
      borderTopStyle: "solid",
      borderTopWidth: "1px",
      backgroundColor: "#004aad",
      borderRadius: "10px 10px 0 0",
    },
  },
  footRow: {
    style: {
      borderTopStyle: "solid",
      borderTopWidth: "1px",
      backgroundColor: "#004aad",
      borderRadius: "10px 10px 0 0",
    },
  },
  headCells: {
    style: {
      "&:not(:last-of-type)": {
        borderRightStyle: "solid",
        borderRightWidth: "1px",
      },
      fontSize: "17px",
      color: "#fff",
      //backgroundColor: "#004aad",
    },
  },

  cells: {
    style: {
      "&:not(:last-of-type)": {
        borderRightStyle: "solid",
        borderRightWidth: "1px",
      },
      fontSize: "16px",
    },
  },
};

const ActiveCertificateCode = () => {
  const [loading, setLoading] = useState(false);
  const [certificateList, setCertificateList] = useState([]);
  const [certificateClickViewDetails, setCertificateClickViewDetails] = useState(null);
  const [receiver, setReceiver] = useState({
    first_name: "",
    last_name: "",
    email: "",
    certificateCode: "",
    secretCode: "",
    authorizationCode: "",
    is_white_level_certificate:""
    // msg: RichTextEditor.createEmptyValue(),
  });

  const [viewData, setViewData] = useState([]);
  const [show, setShow] = useState(false);
  const [actionModalshow, setActionModalShow] = useState(false);
  const [showReport, setshowReport] = useState(false);
  const [msgShow, setmsgShow] = useState(false);
  const [actionmsgShow, setactionmsgShow] = useState(false);
  const [viewReportData, setViewReportData] = useState([]);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleActionModalClose = () => {
    setActionModalShow(false);
    setCertificateId("");
    setcodeId("");
  };
  const handleActionModalShow = () => setActionModalShow(true);
  const handleCloseReport = () => setshowReport(false);
  const handleShowReport = () => setshowReport(true);
  const [certificateId, setCertificateId] = useState("");
  const [codeId, setcodeId] = useState("");
  const [viewOf, setViewOf] = useState("");

  const getList = async () => {
    try {
      setLoading(true);
      await axios
        .get(`/get-all-certificate-with-code-count`, adminConfig())
        .then((res) => {
          setCertificateList(res.data.data);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          console.error(err);
        });
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  // useEffect(() => {
  //     getList();
  // }, [page, limit, search]);
  useEffect(() => {
    getList();
  }, []);

  const modalopenForView = async (id) => {
    handleShow();

    try {
      setLoading(true);
      await axios
        .get(`/get-active-certificate-code/${id}`, adminConfig())
        .then((res) => {
          setViewData(res.data.data);
          handleShow();
          setLoading(false);
          setViewOf(res.data.certificateId);
        })
        .catch((err) => {
          setLoading(false);
          console.error(err);
        });
    } catch (error) {
      setLoading(false);

      console.error(error);
    }
  };

  useEffect(() => {
    if (certificateId !== "" && codeId !== "") {
      handleActionModalShow();
    }
  }, [certificateId, codeId]);

  const actionModalOpen = async (
    certificateId,
    codeId,
    embCode,
    scrtCode,
    authorizationCode
  ) => {
    setCertificateId(certificateId);
    setcodeId(codeId);
    setReceiver({
      ...receiver,
      secretCode: scrtCode,
      certificateCode: embCode,
      authorizationCode: authorizationCode,
    });
  };

  const modalopenForViewReport = async (id) => {
    try {
      setLoading(true);
      await axios
        .get(`/user/commissions/${id}`, adminConfig())
        .then((res) => {
          setViewReportData(res.data.data);
          handleShowReport();
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          console.error(err);
        });
    } catch (error) {
      setLoading(false);

      console.error(error);
    }
  };

  const paidMark = async (id, userId) => {
    setLoading(true);
    await axios
      .get(`/user/commissions-paid/${id}`, adminConfig())
      .then((res) => {
        modalopenForViewReport(userId);
        setLoading(false);
        message.success("Commission Paid Successfully");
        setmsgShow(true);
        setTimeout(() => {
          setmsgShow(false);
        }, 3000);
      })
      .catch((err) => {
        setLoading(false);
        message.error("Commission Unpaid");
        console.error(err);
      });
  };

  const columns = [
    {
      name: "Certificate ID",
      selector: (row) => {
        return <span>{row.certificateId}</span>;
      },
      sortable: true,
      width: "300px",
    },
    {
      name: "Certificate Title",
      selector: (row) => {
        return <span>{row.certificateTitle}</span>;
      },
      sortable: true,
      width: "300px",
    },
    {
      name: "Certificate Code Count",
      selector: (row) => {
        return <span>{row.certificateCodesCount}</span>;
      },
      sortable: true,
      width: "300px",
    },
    {
      name: "View Codes",
      selector: (row) => {
        return (
          <div className="edit_delete_but">
            <button
              type="button"
              className="edit_buttt butttton"
              onClick={() => {
                setCertificateClickViewDetails(row);
                modalopenForView(row.certificateId)
              }}
            >
              View
            </button>
          </div>
        );
      },
      sortable: true,
      width: "400px",
    },
  ];

  const columns_members = [
    {
      name: "Certificate Code",
      selector: (row) => row.certificateEmbeddedCode,
      sortable: true,
      width: "178px",
    },
    {
      name: "Secret Code",
      selector: (row) => row.certificateSecretCode,
      sortable: true,
      width: "150px",
    },
    {
      name: "Created Date",
      selector: (row) => moment(row.createdAt).format("Do MMM YYYY"),
      sortable: true,
      width: "150px",
    },
    {
      name: "Expiry Date",
      selector: (row) => moment(row.expiryAt).format("Do MMM YYYY"),
      sortable: true,
      width: "141px",
    },
    {
      name: "Action",
      selector: (row) => {
        return (
          <div className="edit_delete_but">
            <button
              type="button"
              className="edit_buttt butttton"
              onClick={() =>
                actionModalOpen(
                  row.certificateId,
                  row._id,
                  row.certificateEmbeddedCode,
                  row.certificateSecretCode,
                  row?.certificateAuthorizationCode
                    ? row?.certificateAuthorizationCode
                    : ""
                )
              }
            >
              Assign Code
            </button>
          </div>
        );
      },
      sortable: true,
      width: "220px",
    },
  ];

  const columns_report = [
    {
      name: "Description",
      selector: (row) => row.name,
      sortable: true,
      width: "25%",
    },
    {
      name: "Amount($)",
      selector: (row) => row.amount,
      sortable: true,
      width: "13%",
    },
    {
      name: "Received On",
      selector: (row) => new Date(row.createdAt).toLocaleDateString(),
      sortable: true,
      width: "20%",
    },
    {
      name: "Enrolled User",
      selector: (row) => {
        return (
          <>
            <p>
              <small>Name : {row.sourceUser.name}</small>
            </p>
            <p>
              <small>Email : {row.sourceUser.email}</small>
            </p>
          </>
        );
      },
      sortable: true,
      width: "32%",
    },
    {
      name: "Paid",
      selector: (row) => {
        return (
          <>
            {row.isPaid ? (
              <>
                <input
                  type="checkbox"
                  defaultChecked
                  checked
                  readOnly
                  name=""
                  id=""
                />
              </>
            ) : (
              <>
                <input
                  type="checkbox"
                  onClick={() => paidMark(row.id, row.userId)}
                  name=""
                  id=""
                />
              </>
            )}
          </>
        );
      },
      sortable: true,
      width: "10%",
    },
  ];

  const sendSertificateCode = async (e) => {
    if (receiver.email && receiver.first_name && receiver.last_name) {
      setLoading(true);
      let data = new FormData();
      data.append("first_name", receiver.first_name);
      data.append("last_name", receiver.last_name);
      data.append("email", receiver.email);
      data.append("certificateId", certificateId);
      data.append("codeId", codeId);
      data.append("authorizationCode", receiver.authorizationCode);
      data.append("is_white_level_certificate",receiver.is_white_level_certificate);

      await axios
        .post(`/assign-certificate-code`, data, adminConfig())
        .then(async (res) => {
          if (res.data.status === true) {
            await modalopenForView(certificateId);
            message.success("sent certificate code");
            handleActionModalClose();
            handleClose();
            setReceiver({
              first_name: "",
              last_name: "",
              email: "",
              certificateCode: "",
              secretCode: "",
            });
            setLoading(false);
          } else {
            message.error("failed sending certificate code");
            handleActionModalClose();
            handleClose();
            setLoading(false);
            setReceiver({
              first_name: "",
              last_name: "",
              email: "",
              certificateCode: "",
              secretCode: "",
            });
          }
        })
        .catch((err) => {
          message.error("failed sending certificate code");
          handleActionModalClose();
          handleClose();
          setLoading(false);
          setReceiver({
            first_name: "",
            last_name: "",
            email: "",
            certificateCode: "",
            secretCode: "",
          });
          console.error(err);
        });
    } else {
      setactionmsgShow(true);
      setTimeout(() => {
        setactionmsgShow(false);
      }, 3000);
    }
  };

  return (
    <LoadingOverlay active={loading} spinner text="Loading ...">
      <div className="right_cont">
        <div className="right_banner_banner_cnt">
          <div className="travel_deals_admin">
            <h2>Hello, Admin!</h2>
            <div className="text_field_partts">
              <div className="user_added">
                <h2>Available Certificates</h2>
                <div className="plan_data">
                  <DataTable
                    columns={columns}
                    data={certificateList}
                    pagination
                    striped
                    responsive
                    customStyles={customStyles}
                    subHeaderAlign="right"
                    subHeaderWrap
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal
          show={show}
          onHide={handleClose}
          size="lg"
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
        >
          <Modal.Header>
            <Modal.Title>Available Certificate codes of {viewOf}</Modal.Title>
            <button type="button" className="close" onClick={handleClose}>
              <span aria-hidden="true">×</span>
              <span class="sr-only">Close</span>
            </button>
          </Modal.Header>
          <Modal.Body className="modal-xl">
            <DataTable
              columns={columns_members}
              data={viewData}
              pagination
              striped
              responsive
              customStyles={customStyles}
              subHeaderAlign="right"
              subHeaderWrap
            />
          </Modal.Body>
        </Modal>

        <Modal show={showReport} onHide={handleCloseReport} size="xl">
          <Modal.Header>
            <Modal.Title>Commission Report</Modal.Title>
            <button type="button" class="close" onClick={handleCloseReport}>
              <span aria-hidden="true">×</span>
              <span class="sr-only">Close</span>
            </button>
          </Modal.Header>
          {msgShow ? (
            <>
              <p class="text-center text-success">
                Commission Paid Successfully!
              </p>
            </>
          ) : (
            <></>
          )}
          <Modal.Body className="modal-xl">
            <DataTable
              columns={columns_report}
              data={viewReportData}
              pagination
              striped
              responsive
              customStyles={customStyles}
              subHeaderAlign="right"
              subHeaderWrap
            />
          </Modal.Body>
        </Modal>

        <Modal
          show={actionModalshow}
          onHide={handleActionModalClose}
          size="lg"
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
        >
          <Modal.Header>
            <Modal.Title>Assign Code to User</Modal.Title>
            <button
              type="button"
              class="close"
              onClick={handleActionModalClose}
            >
              <span aria-hidden="true">×</span>
              <span class="sr-only">Close</span>
            </button>
          </Modal.Header>
          <Modal.Body className="modal-xl">
            <p className="text-center text-danger">
              {actionmsgShow ? "Please add all fields" : ""}
            </p>
            <Form>
              <Row>
                <Col md={6}>
                  <Form.Group
                    className="mb-3 certificate_form"
                    controlId="formBasicText"
                  >
                    <Form.Label>First Name</Form.Label>
                    <Form.Control
                      type="text"
                      value={receiver.first_name}
                      placeholder="First Name"
                      className="certificate_field"
                      onChange={(e) =>
                        setReceiver({
                          ...receiver,
                          first_name: e.target.value,
                        })
                      }
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group
                    className="mb-3 certificate_form"
                    controlId="formBasicText"
                  >
                    <Form.Label>Last Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Last Name"
                      className="certificate_field"
                      value={receiver.last_name}
                      onChange={(e) =>
                        setReceiver({
                          ...receiver,
                          last_name: e.target.value,
                        })
                      }
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group
                    className="mb-3 certificate_form"
                    controlId="formBasicEmail"
                  >
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Email"
                      className="certificate_field"
                      value={receiver.email}
                      onChange={(e) =>
                        setReceiver({
                          ...receiver,
                          email: e.target.value,
                        })
                      }
                    />
                  </Form.Group>
                </Col>
                {/* {certificateClickViewDetails?.isHasWhiteLevel && (
                  <Col md={6}>
                    <Form.Group
                      className="mb-3 certificate_form"
                      controlId="formBasicEmail"
                    >
                      <Form.Label>Are you send white level certificate?</Form.Label>
                      <Form.Control
                        as="select"
                        className="tier_index1"
                        name="is_white_level_certificate"
                        onChange={(event) => {
                            setReceiver({
                                ...receiver,
                                is_white_level_certificate: event.target.value
                            })
                        }}
                      >
                        <option value="">Select White Level</option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </Form.Control>
                      
                    </Form.Group>
                  </Col>
                )} */}
                <Col md={6}>
                  <Form.Group
                    className="mb-3 certificate_form"
                    controlId="formBasicEmail"
                  >
                    <Form.Label>Certificate code</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Certificate Code"
                      disabled
                      className="certificate_field"
                      value={receiver.certificateCode}
                    />
                  </Form.Group>
                </Col>
                {receiver.authorizationCode == "" ? (
                  <>
                    <Col md={6}>
                      <Form.Group
                        className="mb-3 certificate_form"
                        controlId="formBasicEmail"
                      >
                        <Form.Label>Secret Code</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Secret Code"
                          disabled
                          className="certificate_field"
                          value={receiver.secretCode}
                        />
                      </Form.Group>
                    </Col>
                  </>
                ) : (
                  <>
                    <Col md={6}>
                      <Form.Group
                        className="mb-3 certificate_form"
                        controlId="formBasicEmail"
                      >
                        <Form.Label>Authorization Code</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Authorization Code"
                          disabled
                          className="certificate_field"
                          value={receiver.authorizationCode}
                        />
                      </Form.Group>
                    </Col>
                  </>
                )}
                <Col md={6}>
                  <button
                    type="button"
                    className="add_but submit_buttt mt-4"
                    onClick={sendSertificateCode}
                  >
                    Submit
                  </button>
                </Col>
              </Row>
            </Form>
          </Modal.Body>
        </Modal>
      </div>
    </LoadingOverlay>
  );
};

export default ActiveCertificateCode;
